export default "__VITE_ASSET__C8mKdRpd__"